/* eslint-disable max-len */
import queryRoutes from './query.routes.js';
import calcRouteRoutes from './calc-route.routes.js';
import scaleCalibrationRoutes from './scale-calibration.routes.js';
import {reactive} from 'vue';

import {MENU_ITEM_SCALES} from '@/util-scale.js';
import {EXTENSION_REGIONS_MENU_ROUTES} from './extension-regions.routes.js';

export default [...queryRoutes, ...calcRouteRoutes, ...scaleCalibrationRoutes];

export class MenuHierarchyItem {
  id; // string
  name; // string
  title; // string
  icon; // string
  materialIcon; // string
  children = []; // MenuHierarchyItem
  route; // Route | string
}

export const menuHierarchy$$ = reactive([
  {
    id: 'queries', title: 'Consultas', icon: 'compass', children: [
      {
        id: 'query-towns', title: 'Poblaciones',
        route: {name: 'queryTowns'}, materialIcon: 'location_city',
      },
      {
        id: 'query-tourist-routes', title: 'Rutas Turísticas',
        route: {name: 'queryTouristRoutes'}, materialIcon: 'tour',
      },
      {
        id: 'query-poi', title: 'Lugares de interés',
        route: {name: 'queryPOI'}, materialIcon: 'visibility',
      },
      {
        id: 'query-national-parks', title: 'Parques nacionales',
        route: {name: 'queryNationalParks'}, materialIcon: 'forest',
      },
      {
        id: 'query-protected-areas', title: 'Espacios protegidos',
        route: {name: 'queryProtectedAreas'}, materialIcon: 'eco',
      },
      {
        id: 'query-ways-st-james', title: 'Camino de Santiago',
        route: {name: 'queryWaysStJames'}, materialIcon: 'hiking',
      },
      {
        id: 'query-beaches', title: 'Playas',
        route: {name: 'queryBeaches'}, materialIcon: 'beach_access',
      },
      {
        id: 'query-green-ways', title: 'Vías verdes/Rutas Ciclistas',
        route: {name: 'queryGreenWays'}, materialIcon: 'nature_people',
      },
      {
        id: 'query-photos', title: 'Fotos',
        route: {name: 'queryPhotos'}, materialIcon: 'photo_camera',
      },
      {
        id: 'query-service-areas', title: 'Áreas de servicio',
        route: {name: 'queryServiceAreas'}, materialIcon: 'local_gas_station',
      },
      {
        id: 'query-mountain-ports', title: 'Puertos de montaña',
        route: {name: 'queryMountainPorts'}, materialIcon: 'landscape',
      },
      {
        id: 'query-public-works', title: 'Obras públicas',
        route: {name: 'queryPublicWorks'}, materialIcon: 'account_balance',
      },
    ],
  },
  {
    id: 'route-calc', title: 'Cálculo de rutas',
    icon: 'car', route: {name: 'calcRoute'},
  },
  {
    id: 'dpc-calibration',
    title: 'Calibrar PPC',
    icon: 'calculator',
    route: {name: 'dpcCalibration'},
  },
  {
    id: 'change-scale', title: 'Cambiar escala', materialIcon: 'design_services',
    children: MENU_ITEM_SCALES,
  },
  {
    id: 'zoom-region', title: 'Centrar en región',
    icon: 'search',
    customClass: 'zoom-region-menu',
    children: EXTENSION_REGIONS_MENU_ROUTES,
  },
  {id: 'print', title: 'Imprimir', icon: 'print'},
  {id: 'links', title: 'Enlaces', materialIcon: 'link',
    children: [
      {
        id: 'maps', title: 'Google Maps', icon: 'map',
      },
      {
        id: 'earth', title: 'Google Earth', materialIcon: 'public',
      },
    ],
  },
  {
    id: 'font-size', title: 'Tamaño de fuente', materialIcon: 'font_download',
    children: [
      {
        id: 'font-size:default', title: 'Por defecto',
        materialIcon: 'font_download',
      },
      {
        id: 'font-size:increase', title: 'Tamaño letra ',
        materialIcon: 'text_increase',
      },
      {
        id: 'font-size:decrease', title: 'Tamaño letra',
        materialIcon: 'text_decrease',
      },
    ],
  },
  {
    id: 'about', title: 'Acerca del Mapa Oficial de Carreteras',
    route: {name: 'About'}, icon: 'question-circle',
  },
]);
